import { CSSProperties } from "react";
import { Input } from "antd";
import type { TextAreaProps } from "antd/es/input";

export type UITextAreaProps = TextAreaProps & {
  fullWidth?: boolean;
  sx?: Record<string, unknown>;
};

export const UITextArea = ({
  fullWidth,
  sx,
  style,
  ...props
}: UITextAreaProps) => {
  const sxStyle = (sx ?? {}) as CSSProperties;
  return (
    <Input.TextArea
      style={{
        ...(fullWidth ? { width: "100%" } : {}),
        ...sxStyle,
        ...style,
      }}
      {...props}
    />
  );
};
